











































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Utils } from "@/services/utils";
import { ShatenService } from "@/services/shaten.service";
import Pagination from "@/views/components/Pagination.vue";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import InputNumber from "@/views/components/input/InputNumber.vue";
import { CommonService } from "@/services/Common.service";
import { AccountService } from "@/services/account.service.ts";
import { CheckExpTablesService } from "@/services/CheckExpTables.service";
import Number from "@/shared/filters/Number";
interface ShatenItem {
  groupCd: string;
  shatenCd: string;
  dataStateKbn: number;
  shuukeiKbn: number | null;
  kaishaNm: string;
}

@Component({
  filters: {
    Number
  },
  components: {
    Pagination,
    InputNumber
  },
  mixins: [FilterSelectBox]
})
export default class ShatenManagement extends Vue {
  @Prop({ default: "" })
  title: string;
  util: Utils = new Utils();
  shatenService: ShatenService = new ShatenService();
  checkExpTablesService: CheckExpTablesService = new CheckExpTablesService();
  loading = true;
  itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  itemSizeSelected: number = 10;
  objAdd: ShatenItem = {
    groupCd: "",
    shatenCd: "",
    kaishaNm: "",
    dataStateKbn: 1,
    shuukeiKbn: null
  };
  groupDataList: any = [];
  shatenDataList: any = [];
  shuukeiDataList: any = [];
  shuukeiDataEditList: any = [];
  data: any = [];
  dataPageList: any = [];
  objEdit: any = {};
  loadingKyoten = false;
  kyotenDataList: any = [];
  showAccountDialog = false;
  showEditDialog = false;

  accountService = new AccountService();
  commonService = new CommonService();
  showCloneDialog = false;
  objClone: any = {
    fromVersionCd: null,
    toVersionCd: null
  };
  groupDataList1: any = [];
  shatenDataList1: any = [];
  kyotenDataList1: any = [];
  versionList: any = [];
  paramClone: any = {
    groupCd: "",
    shatenCd: "",
    kyotenCd: "",
    version: ""
  };
  cloneLoading = false;

  loadingSeibiMenu = false;
  showDialogSeibiMenu = false;
  feeList: any = [];
  seibiMenuFeeList: any = [];
  tempVersionId = 0;

  showDialogSmsupload = false;
  showDialogSmsuploadItem: any = {};
  loadingSmsupload = false;
  showCheckExpTablesList: any = [];

  showDialogShatenExtension = false;
  loadingShatenExtension = false;
  showShatenExtensionList: any = [];

  itemUseList: any[] = [
    { label: "利用なし", value: "0" },
    { label: "利用中", value: "1" }
  ];
  shatenExtensionSelectVersionId: number = 0;
  showDialogSknCondition = false;
  jizenId: any = null;
  jizenFlg: boolean = false;
  extremeId: any = null;
  extremeFlg: boolean = false;
  copyId: any = null;
  copyFlg: boolean = false;
  controlId: any = null;
  controlFlg: boolean = false;
  recommendId: any = null;
  recommendFlg: boolean = false;


  /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [START] */
  jizenExpExportId: any = null;
  jizenExpExportFlg: boolean = false;
  /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [END] */

  /** 2023-10-19 invoice [START] */
  editableZnId: any = null;
  editableZnFlg: boolean = false;
  /** 2023-10-19 invoice [END] */

  /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [START] */
  showZenKanaId: any      = null;
  showZenKanaFlg: boolean = false;
  /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [END] */
  // 2023-08-00 BQR809(1092) add 事前見積並び順 [START]
  jizenSortId: any = null;
  jizenSortFlg: boolean = false;
  // 2023-08-00 BQR809(1092) add 事前見積並び順 [END]

  created() {
    this.getGroupList();
    this.getData();
  }

  async getData() {
    this.loading = true;
    const res = await this.shatenService.getCompanyList();
    this.loading = false;
    if (res) {
      this.data = res;
    } else {
      this.data = [];
      this.dataPageList = [];
    }
  }

  async getGroupList() {
    const res = await this.shatenService.getGroupList();
    if (res) {
      this.groupDataList = res;
    } else {
      this.groupDataList = [];
    }
  }

  async getShatenList(groupCd: string) {
    const res = await this.shatenService.getShatenList(groupCd);
    if (res) {
      this.shatenDataList = res;
    } else {
      this.shatenDataList = [];
    }
  }

  getShatenNm(item: any) {
    return item.kaishaNm + "(" + item.shatenCd + ")";
  }

  getShuukei(item: any) {
    if (item.shuukeiKbn) {
      let shuukei = "";
      if (item.shuukeiNm) {
        shuukei = item.shuukeiNm;
      }
      shuukei += "(" + item.shuukeiKbn + ")";
      return shuukei;
    }
    return "";
  }

  clearAddData() {
    this.objAdd = {
      groupCd: "",
      shatenCd: "",
      kaishaNm: "",
      dataStateKbn: 1,
      shuukeiKbn: null
    };
  }

  async onAddData() {
    if (this.objAdd.groupCd && this.objAdd.shatenCd) {
      const res = await this.shatenService.addCompany(this.objAdd);
      if (res == 200) {
        this.getData();
        this.clearAddData();
      } else {
        this.$message.error("エラー");
      }
    }
  }

  selectGroup() {
    this.objAdd.shatenCd = "";
    this.getShatenList(this.objAdd.groupCd);
  }

  selectShaten(shatenCd: any) {
    const shaten = this.shatenDataList.find(
      (e: any) => e.shatenCd === shatenCd
    );
    if (shaten) {
      this.objAdd.kaishaNm = shaten.kaishaNm;
    }
    this.getShuukeiList();
  }

  async getShuukeiList() {
    const res = await this.shatenService.getShuukeiList(
      this.objAdd.groupCd,
      this.objAdd.shatenCd
    );

    if (res) {
      this.shuukeiDataList = res;
    } else {
      this.shuukeiDataList = [];
    }
  }

  async getShuukeiEditList() {
    const res = await this.shatenService.getShuukeiList(
      this.objEdit.groupCd,
      this.objEdit.shatenCd
    );

    if (res) {
      this.shuukeiDataEditList = res;
    } else {
      this.shuukeiDataEditList = [];
    }
  }

  onEdit(item: any) {
    this.showEditDialog = true;
    this.objEdit = this.util.deepCopy(item);
    this.getShuukeiEditList();
  }

  async openAccountDialog(item: any) {
    this.showAccountDialog = true;
    this.kyotenDataList = [];
    this.loadingKyoten = true;
    this.objEdit = this.util.deepCopy(item);
    const res = await this.shatenService.getCompanyKyoten(
      item.groupCd,
      item.shatenCd
    );
    this.loadingKyoten = false;
    if (res) {
      this.kyotenDataList = res;
    }
  }

  isNoTel(kyoten: any) {
    return !kyoten.tel1 || !kyoten.tel2 || !kyoten.tel3;
  }

  async updateCompany() {
    const obj = {
      groupCd: this.objEdit.groupCd,
      shatenCd: this.objEdit.shatenCd,
      shuukeiKbn: this.objEdit.shuukeiKbn,
      dataStateKbn: this.objEdit.dataStateKbn
    };
    const res = await this.shatenService.updateCompany(obj);
    if (res == 200) {
      this.getData();
    } else {
      this.$message.error("エラー");
    }
    this.showEditDialog = false;
  }

  async onSubmitAccoutDialog() {
    const obj = this.kyotenDataList
      .filter((e: any) => e.sknLiftCnt != null)
      .map((e: any) => {
        return {
          groupCd: this.objEdit.groupCd,
          shatenCd: this.objEdit.shatenCd,
          kyotenCd: e.kyotenCd,
          sknLiftCnt: e.sknLiftCnt
        };
      });
    const res = await this.shatenService.saveKyotenJyouhou(obj);
    if (res == 200) {
      this.getData();
    } else {
      this.$message.error("エラー");
    }
    this.showAccountDialog = false;
  }

  async onCreateCompanyAccount(kyoten: any) {
    const obj = {
      groupCd: this.objEdit.groupCd,
      shatenCd: this.objEdit.shatenCd,
      kyotenCd: kyoten.kyotenCd
    };
    const res = await this.shatenService.createCompanyAccount(obj);
    if (res == 200) {
      kyoten.isCreated = 1;
    } else {
      this.$message.error("エラー");
    }
  }

  openCloneDialog(toVersionCd: number) {
    this.showCloneDialog = true;
    this.groupDataList1 = this.util.deepCopy(this.groupDataList);
    this.shatenDataList1 = [];
    this.kyotenDataList1 = [];
    this.versionList = [];

    this.objClone = {
      fromVersionCd: null,
      toVersionCd
    };
    this.paramClone = {
      groupCd: "",
      shatenCd: "",
      kyotenCd: "",
      version: ""
    };
  }

  selectGroup1() {
    this.objClone.fromVersionCd = null;
    this.kyotenDataList1 = [];
    this.versionList = [];
    this.getShatenDataList();
  }

  selectShaten1() {
    this.objClone.fromVersionCd = null;
    this.kyotenDataList1 = [];
    this.versionList = [];
    this.getKyotenDataList();
  }

  async selectKyoten1() {
    this.objClone.fromVersionCd = null;
    this.getVersionList();
  }

  async getKyotenDataList() {
    const response = await this.accountService.getKyotens(
      this.paramClone.groupCd,
      this.paramClone.shatenCd
    );
    if (response) {
      this.$set(this, "kyotenDataList1", response);
    } else {
      this.$set(this, "kyotenDataList1", []);
    }
    if (this.kyotenDataList1.length === 0) {
      this.getVersionList();
    }
  }

  async getShatenDataList() {
    if (this.paramClone.groupCd) {
      const response = await this.accountService.getShatens(
        this.paramClone.groupCd
      );
      if (response) {
        this.$set(this, "shatenDataList1", response);
      } else {
        this.$set(this, "shatenDataList1", []);
      }
    }
  }

  async getVersionList() {
    if (this.paramClone.groupCd && this.paramClone.shatenCd) {
      const response = await this.commonService.getHanyouSeibiVersion(
        this.paramClone.groupCd,
        this.paramClone.shatenCd,
        this.paramClone.kyotenCd
      );
      this.$set(this, "versionList", response);
    }
  }

  async onClone() {
    this.$set(this, "cloneLoading", true);
    const status = await this.shatenService.shakenInspectClone(this.objClone);
    this.$set(this, "cloneLoading", false);
    if (status === 200) {
      this.showCloneDialog = false;
      this.getData();
    } else {
      this.$message.error("エラー");
    }
  }

  async openSeibiMenuDialog(versionId: number) {
    this.showDialogSeibiMenu = true;
    this.loadingSeibiMenu = true;
    this.tempVersionId = versionId;
    this.feeList = [];
    this.seibiMenuFeeList = [];
    this.feeList = await this.shatenService.getInspectMenuFee(versionId);
    const data = await this.shatenService.getSeibiMenuInspectFeeMap(versionId);
    this.seibiMenuFeeList = data.filter((e: any) => e.seibiMenuCd);
    this.loadingSeibiMenu = false;
  }

  async onSaveSeibiInspectFee() {
    this.loadingSeibiMenu = true;
    const data1 = this.seibiMenuFeeList.filter(
      (e: any) => e.sknInspectSeibiFeeId != null
    );

    const data = data1.map(
      (e: any) => {
        const newObj = {
          ...e
        };

        delete newObj.isUseDiscount;
        delete newObj.discountRate;
        return newObj;
      }
    );

    const status = await this.shatenService.saveSeibiMenuInspectFeeMap(data);
    this.$set(this, "loadingSeibiMenu", false);
    if (status === 200) {
      this.showDialogSeibiMenu = false;
    } else {
      this.$message.error("エラー");
    }
  }

  async openSmsDialog(item: any) {
    this.showDialogSmsupload = true;
    this.showDialogSmsuploadItem = item;

    this.$set(this, "loadingSmsupload", true);
    this.showCheckExpTablesList = [];
    const response = await this.checkExpTablesService.getCheckExpTablesTbList(
      {
        groupCd: item.groupCd,
        shatenCd: item.shatenCd
      }
    );
    this.$set(this, "loadingSmsupload", false);
    if (response) {
      this.showCheckExpTablesList = response.map((e: any) => {
        return { ...e, isInit: true, isExpTablesRowLoading: false};
      });
      this.showCheckExpTablesList.forEach((e: any) => {
        this.getExpTableTbCnt(e.id, item);
      });
    }
  }

  async onGetExpTableTbCnt(id: any) {
    this.$set(this, "loadingSmsupload", true);
    let item = this.showDialogSmsuploadItem;
    this.getExpTableTbCnt(id, item);
    this.$set(this, "loadingSmsupload", false);
  }

  async getExpTableTbCnt(id: any, item: any) {
    this.showCheckExpTablesList = this.showCheckExpTablesList.map((e: any) => {
        if (id == e.id) {
          e.isExpTablesRowLoading = true;
        }
        return { ...e};
    });
    const response = await this.checkExpTablesService.getCheckExpTablesTbCnt(id,
      {
        groupCd: item.groupCd,
        shatenCd: item.shatenCd
      }
    );
    if (response) {
      this.showCheckExpTablesList = this.showCheckExpTablesList.map((e: any) => {
        if (response.id == e.id) {
          e.expTableCnt = response.expTableCnt;
          e.sknTableCnt = response.sknTableCnt;
          e.isInit = false;
          e.isExpTablesRowLoading = false;
        }
        return { ...e};
      });
    }
  }

  async openShatenExtensionDialog(id: number) {
    this.showDialogShatenExtension = true;
    this.shatenExtensionSelectVersionId = id;

    this.$set(this, "loadingShatenExtension", true);
    this.showCheckExpTablesList = [];
    const response = await this.shatenService.getShatenExtension(id);
    this.$set(this, "loadingShatenExtension", false);
    if (response) {
      this.showShatenExtensionList = response;
    }
  }

  async onSaveShatenExtension(extension: any) {
    let id = this.shatenExtensionSelectVersionId;
    const res = await this.shatenService.saveShatenExtension(id, extension);
    if (res == 200) {
      this.$message.success( extension.extensionNm + "を更新しました。");
    } else {
      this.$message.error("エラー");
    }
    this.showEditDialog = false;
  }

  isSuccess(param: any) {
    if (param.isRequired === 0) {
      return true;
    }
    if (param.expTableCnt <= param.sknTableCnt) {
      return true;
    }
    return false;
  }

  chkDisabled(extension: any) {
    if (!extension.extensionVal) {
      return true;
    }
    return false;
  }

  async openSknConditionDialog(id: number) {
    this.showDialogSknCondition = true;
    this.shatenExtensionSelectVersionId = id;
    this.$set(this, "loadingShatenExtension", true);
    this.showCheckExpTablesList = [];
    // 毎回初期化する
    this.jizenId = null;
    this.jizenFlg = false;
    this.extremeId = null;
    this.extremeFlg = false;
    this.copyId = null;
    this.copyFlg = false;
    this.controlId = null;
    this.controlFlg = false;
    this.recommendId = null;
    this.recommendFlg = false;
    /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [START] */
    this.jizenExpExportId   = null;
    this.jizenExpExportFlg  = false;
    /** 2023-10-19 invoice [START] */
    this.editableZnId   = null;
    this.editableZnFlg = false;
    /** 2023-10-19 invoice [END] */
    /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [END] */
    /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [START] */
    this.showZenKanaId      = null;
    this.showZenKanaFlg     = false;
    /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [END] */
    // 2023-08-00 BQR809(1092) add 事前見積並び順 [START]
    this.jizenSortId = null;
    this.jizenSortFlg = false;
    // 2023-08-00 BQR809(1092) add 事前見積並び順 [END]
    // 初期化ここまで
    const response = await this.shatenService.getShatenSknExtension(id);
    this.$set(this, "loadingShatenExtension", false);
    if (response && response.length > 0) {
      response.forEach((element: any) => {
        if (element.extensionKey == 1) {
          this.jizenId = element.id;
          this.jizenFlg = Number(element.extensionVal) == 1;
        } else if (element.extensionKey == 2) {
          this.extremeId = element.id;
          this.extremeFlg = Number(element.extensionVal) == 1;
        } else if (element.extensionKey == 3) {
          this.copyId = element.id;
          this.copyFlg = Number(element.extensionVal) == 1;
        } else if (element.extensionKey == 4) {
          this.controlId = element.id;
          this.controlFlg = Number(element.extensionVal) == 1;
        } else if (element.extensionKey == 5) {
          this.recommendId = element.id;
          this.recommendFlg = Number(element.extensionVal) == 1;
        /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [START] */
        } else if (element.extensionKey == 6) {
          this.jizenExpExportId  = element.id;
          this.jizenExpExportFlg = Number(element.extensionVal) == 1;
        /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [END] */
        /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [START] */
        } else if (element.extensionKey == 7) {
          this.showZenKanaId  = element.id;
          this.showZenKanaFlg = Number(element.extensionVal) == 1;
        /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [END */
        // 2023-08-00 BQR809(1092) add 事前見積並び順 [START]
        } else if (element.extensionKey == 8) {
          this.jizenSortId = element.id;
          this.jizenSortFlg = Number(element.extensionVal) == 1;
        // 2023-08-00 BQR809(1092) add 事前見積並び順 [END]
        /** 2023-10-19 invoice [START] */
        } else if (element.extensionKey == 10) {
          this.editableZnId  = element.id;
          this.editableZnFlg = Number(element.extensionVal) == 1;
        }
        /** 2023-10-19 invoice [END] */
      });
    }
  }

  async onSaveShatenSknExtension() {
    let id = this.shatenExtensionSelectVersionId;
    let params = [{
      id: this.jizenId
      , extensionNm: '事前見積機能'
      , extensionKey: 1
      , extensionVal: this.jizenFlg ? '1': '0'
    }, {
      id: this.extremeId
      , extensionNm: 'extreme明細取込'
      , extensionKey: 2
      , extensionVal: this.extremeFlg ? '1': '0'
    }, {
      id: this.copyId
      , extensionNm: '事前見積引用'
      , extensionKey: 3
      , extensionVal: this.jizenFlg && this.copyFlg ? '1' : '0'
    }, {
      id: this.controlId
      , extensionNm: '認証工場メニュー制御'
      , extensionKey: 4
      , extensionVal: this.controlFlg ? '1' : '0'
    }, {
      id: this.recommendId
      , extensionNm: 'おすすめ整備制御'
      , extensionKey: 5
      , extensionVal: this.recommendFlg ? '1' : '0'
    /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [START] */
    }, {
      id: this.jizenExpExportId
      , extensionNm: '事前見積でextreme取込'
      , extensionKey: 6
      , extensionVal: this.jizenExpExportFlg ? '1': '0'
    /** 2023-06-01 sh #8338(BQR1069) implements export to extreme when save mitsumori for jizen. [END] */
    /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [START] */
    }, {
      id: this.showZenKanaId
      , extensionNm: '点検名称全角カナ表示'
      , extensionKey: 7
      , extensionVal: this.showZenKanaFlg ? '1': '0'
    /** 2023-07-03 sh #8385(BQR1118) change Katakana from Han to Zen. [END] */
    // 2023-08-00 BQR809(1092) add 事前見積並び順 [START]
    }, {
      id: this.jizenSortId
      , extensionNm: '事前見積並び順'
      , extensionKey: 8
      , extensionVal: this.jizenSortFlg ? '1' : '0'
    // 2023-08-00 BQR809(1092) add 事前見積並び順 [END]
    /** 2023-10-19 invoice [START] */
    }, {
      id: this.editableZnId
      , extensionNm: '税抜き'
      , extensionKey: 10
      , extensionVal: this.editableZnFlg ? '1': '0'
    }];
    /** 2023-10-19 invoice [END] */
    const res = await this.shatenService.saveShatenSknExtension(id, params);
    if (res == 200) {
      this.showDialogSknCondition = false;
    } else {
      this.$message.error("エラー");
    }
  }
}
